export enum CropOrientation {
  LEFT_TOP = 'leftTop',
  RIGHT_TOP = 'rightTop',
  LEFT_BOTTOM = 'leftBottom',
  RIGHT_BOTTOM = 'rightBottom',
  MIDDLE_LEFT = 'middleLeft',
  MIDDLE_RIGHT = 'middleRight',
  MIDDLE_TOP = 'middleTop',
  MIDDLE_BOTTOM = 'middleBottom',
  DEFAULT = '',
}

export type Crop = {
  left: number,
  right: number,
  top: number,
  bottom: number,
};
